import Common from '../common/CommonPowerbook';

class TmplObjectQuest {

    constructor() {
        this.comm = Common.instance;
    }

    make(_d){
         return `
<section class="object object-monster">
    <header class="object__header">
        <img class="object__icon" src="${this.comm.staticImgURL}/owerbook/lineage/${_d.image}" alt="">
        <span class="object__name"><a href="${this.comm.powerbookURL}/${_d.name}">${_d.name}</a></span>
    </header>
    <article class="object__attribute">
        <table>
            <tbody>
                <tr>
                    <th scope="col">시작 위치</th>
                    <td><a href="${this.comm.powerbookURL}/${_d.start_location}">${_d.start_location}</a></td>
                </tr>
                <tr>
                    <th scope="col">시작 NPC</th>
                    <td><a href="${this.comm.powerbookURL}/${_d.start_npc}">${_d.start_npc}</a></td>
                </tr>
                <tr>
                    <th scope="col">퀘스트 유형</th>
                    <td>${_d.quest_type||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">제한 조건</th>
                    <td>${_d.condition||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">보상</th>
                    <td>
                        <p>${this.rewardList(_d.reward)}</p>
                        <p>${_d.reward_etc||'-'}</p>
                    </td>
                </tr>
            </tbody>
        </table>
    </article>
</section>`
    }

    rewardList(_d){
        if(!_d || !_d.length) return '';

        return _d.map( item =>{
            if ( item=="- 택 1") return item;
            return `<a href="${this.comm.powerbookURL}/${item}">${item}</a>`;
        }).join(', ');
    }

}

export default TmplObjectQuest;




// WEBPACK FOOTER //
// ./lineage/TmplObjectQuest.js